import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "reindex" }

import { ref, useTemplateRef, defineAsyncComponent } from 'vue';

import { showInfo } from '@services/utils/dialog';

import Modal from './Modal.vue';

import { useModal } from '@services/modal';
import { n, t } from '@services/l10n';
import { isAbortError, useAbort } from '@services/utils/abort-vue';
import * as dav from '@services/dav';
import * as utils from '@services/utils/common';

import type { IPhoto } from '@typings';


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'ReindexModal',
},
  __name: 'ReindexModal',
  setup(__props) {

const NcProgressBar = defineAsyncComponent(() => import('@nextcloud/vue/components/NcProgressBar'));



const modal = useTemplateRef('modal');
const { show, close } = useModal(modal);

const photos = ref<IPhoto[]>([]);
const photosDone = ref(0);
const abort = useAbort();

console.assert(!_m.modals.reindex, 'ReindexModal created twice');
_m.modals.reindex = open;

function open(photosIn: IPhoto[]) {
  photos.value = photosIn;
  photosDone.value = 0;
  if (!photosIn.length) return;
  show.value = true;
  void run();
}

function cleanup() {
  abort.abort();
  show.value = false;
  photos.value = [];
}

async function run() {
  const signal = abort.renew();
  try {
    const ok = await dav.reindexPhotos(
      photos.value,
      (done) => {
        if (!signal.aborted) {
          photosDone.value = done;
        }
      },
      { signal },
    );
    signal.throwIfAborted();

    showInfo(n('memories', '{n} file refreshed', '{n} files refreshed', ok, { n: ok }));
    close();
    utils.bus.emit('memories:timeline:soft-refresh', null);
  } catch (e) {
    if (isAbortError(e)) return;
    throw e;
  }
}

return (_ctx: any,_cache: any) => {
  return (_unref(show))
    ? (_openBlock(), _createBlock(Modal, {
        key: 0,
        ref_key: "modal",
        ref: modal,
        onClose: cleanup,
        size: "normal"
      }, {
        title: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('memories', 'Refresh metadata')), 1)
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", null, _toDisplayString(_unref(n)('memories', 'Processing {n} file', 'Processing {n} files', photos.value.length, {
            n: photos.value.length,
          })), 1),
            _createVNode(_unref(NcProgressBar), {
              value: Math.round((photosDone.value * 100) / Math.max(photos.value.length, 1)),
              error: true
            }, null, 8, ["value"])
          ])
        ]),
        _: 1
      }, 512))
    : _createCommentVNode("", true)
}
}

})